export default __webpack_public_path__ + "static/media/feedback.3bf3411a.png";